import script from "./customNoteToMixDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./customNoteToMixDetail.vue?vue&type=script&setup=true&lang=js"

import "./customNoteToMixDetail.vue?vue&type=style&index=0&id=08a074e0&lang=less"

const __exports__ = script;

export default __exports__